import React, { useState } from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Alert,
  Modal,
  ModalBody,
  Spinner,
} from 'reactstrap';
import { exportDataset } from '../api/exportApi';

export function ExportDatasetPage() {
  const [message, setMessage]   = useState(null);
  const [loading, setLoading]   = useState(false);   // NEW

  const handleExport = async (filter) => {
    setMessage(null);
    setLoading(true);                                 // show spinner
    try {
      const blob = await exportDataset(filter);
      const url  = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement('a');
      link.href  = url;
      link.setAttribute('download', `${filter}-photos.zip`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      setMessage(`Your ${filter.replace('-', ' ')} dataset is downloading…`);
    } catch (err) {
      console.error(err);
      setMessage('Export failed. Please try again.');
    } finally {
      setLoading(false);                              // hide spinner
    }
  };

  return (
    <div className="page-content">
      <Row>
        <Col xs={12}>
          <div className="page-title-box d-flex align-items-center justify-content-between">
            <h4 className="mb-0">Export Dataset</h4>
          </div>
        </Col>
      </Row>

      {message && (
        <Alert
          color={message.toLowerCase().startsWith('export failed') ? 'danger' : 'success'}
          className="mt-3"
        >
          {message}
        </Alert>
      )}

      <Row className="mt-4">
        <Col md={4}>
          <Card>
            <CardBody className="text-center">
              <h5>All Audited Photos</h5>
              <Button color="success" onClick={() => handleExport('audited')} disabled={loading}>
                Export
              </Button>
            </CardBody>
          </Card>
        </Col>

        <Col md={4}>
          <Card>
            <CardBody className="text-center">
              <h5>All Unaudited Photos</h5>
              <Button color="warning" onClick={() => handleExport('unaudited')} disabled={loading}>
                Export
              </Button>
            </CardBody>
          </Card>
        </Col>

        <Col md={4}>
          <Card>
            <CardBody className="text-center">
              <h5>All Photos</h5>
              <Button color="primary" onClick={() => handleExport('all')} disabled={loading}>
                Export
              </Button>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* Loading modal */}
      <Modal centered isOpen={loading} backdrop="static">
        <ModalBody className="d-flex flex-column align-items-center">
          <Spinner style={{ width: '3rem', height: '3rem' }} />
          <p className="mt-3 mb-0 fw-semibold">Compiling Dataset to Export…</p>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default ExportDatasetPage;

